import Vue from "vue";

export const userModule = {
    namespaced: true,
    state: () => ({
    token: "123",
}),
    mutations: {
    getToken(state, val) {
        state.token = val;
        Vue.cookies.set("token", val);
    }
},

}
